import { theme } from '@/theme'

export const getIsInSafari = () => {
	if (typeof window === 'undefined') {
		return false
	}
	const userAgent = navigator.userAgent
	return (
		/Safari/.test(userAgent) &&
		!/Chrome/.test(userAgent) &&
		!/Chromium/.test(userAgent)
	)
}

export const getPageZoom = () => {
	if (typeof window === 'undefined') {
		return 1
	}

	return Math.round((window.outerWidth / window.innerWidth) * 100) / 100
}

export const isTouchDevice =
	typeof window !== 'undefined' && 'ontouchstart' in window

export const isDesktop = () =>
	window.matchMedia(`(min-width: ${theme.screens.desktop})`).matches
